import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-8 md:py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-136">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="relative rounded-3xl bg-primary-card border border-accent-cyan/30 p-1 overflow-hidden" data-id="element-137">
        {/* Animated border effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-accent-cyan/0 via-accent-cyan/50 to-accent-cyan/0 opacity-20 animate-[spin_4s_linear_infinite] blur-xl" data-id="element-138"></div>

        <div className="relative bg-primary-card rounded-[23px] p-5 md:p-10 flex flex-col items-center text-center z-10" data-id="element-139">
          <div className="bg-accent-orange text-primary font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-wider mb-4 md:mb-6 animate-pulse" data-id="element-140">
            El precio bonificado termina hoy.
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-141">
            PACK QUÍMICA TOTAL 360
          </h2>
          <h3 className="text-lg md:text-xl text-text-muted mb-4 md:mb-6" data-id="element-142">
            16 Tomos • Sistema Completo
          </h3>

          <div className="mb-4 md:mb-6 flex flex-col items-center" data-id="element-143">
            <span className="text-2xl text-text-muted line-through decoration-accent-red/50 decoration-2 mb-1 md:mb-2" data-id="element-144">
              $60.000
            </span>
            <div className="flex items-start gap-2" data-id="element-145">
              <span className="text-5xl md:text-7xl font-heading font-bold text-accent-cyan" data-id="element-146">
                $24.990
              </span>
              <span className="text-xl text-accent-cyan font-bold mt-2" data-id="element-147">
                ARS
              </span>
            </div>
          </div>

          <ul className="space-y-2 md:space-y-3 mb-6 md:mb-8 text-left w-full max-w-md mx-auto" data-id="element-148">
            {['Acceso de por vida a las 4 tecnicaturas', 'Cuadernillos listos para imprimir', 'Garantía de satisfacción 7 días'].map((benefit, index) => <li key={index} className="flex items-center gap-3 text-base md:text-lg" data-id="element-149">
                <div className="bg-accent-green/20 p-1 rounded-full shrink-0" data-id="element-150">
                  <Check className="w-5 h-5 text-accent-green" data-id="element-151" />
                </div>
                <span data-id="element-152">{benefit}</span>
              </li>)}
          </ul>

          <motion.a href="https://checkout.guiadigital360.online/cart/44924930719813:1" target="_blank" rel="noopener noreferrer" animate={{
          boxShadow: ['0 0 20px rgba(0, 200, 83, 0.3)', '0 0 40px rgba(0, 200, 83, 0.6)', '0 0 20px rgba(0, 200, 83, 0.3)'],
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-full max-w-md bg-accent-green hover:bg-[#00b34a] text-primary font-bold text-lg md:text-xl px-8 py-4 md:py-5 rounded-xl transition-all transform hover:scale-105 inline-block text-center" data-id="element-153">
            SÍ, QUIERO EL SISTEMA TOTAL 360
          </motion.a>
        </div>
      </motion.div>
    </section>;
}